export default __webpack_public_path__ + "static/media/Front-Villa-Baydoun-in-Bhamdoun.fd7e727e.jpg";